import { Pipe, PipeTransform } from '@angular/core';
import '@angular/localize/init';

@Pipe({
  name: 'timeAgo',
  standalone: true,
  pure: true,
})
// export class TimeAgoPipe implements PipeTransform {
//   transform(value: unknown): string {
//     if (typeof value !== 'string') {
//       return '';
//     }

//     const date = moment.utc(value as string);
//     const timeUnits: any[] = [$localize`year`, $localize`month`, $localize`day`, $localize`hour`, $localize`minute`];
//     const diffs = timeUnits.map((unit) => moment().diff(date, unit));
//     const index = diffs.findIndex((diff) => diff > 0);

//     if (index !== -1) {
//       const diff = diffs[index];
//       const unit = timeUnits[index];
//       return `${diff} ${unit}${diff === 1 ? $localize` ago` : $localize`s ago`}`;
//     } else {
//       return $localize`Just now`;
//     }
//   }
// }
export class TimeAgoPipe implements PipeTransform {
  transform(value: string | Date | any): string {
    if (!value) {
      return $localize`Invalid date`;
    }

    const date = new Date(value);
    const now = new Date();
    const diffInSeconds = Math.floor((now.getTime() - date.getTime()) / 1000);

    if (diffInSeconds < 60) {
      return $localize`Just now`;
    }

    const units: { unit: Intl.RelativeTimeFormatUnit; secondsInUnit: number }[] = [
      { unit: 'year', secondsInUnit: 31536000 },
      { unit: 'month', secondsInUnit: 2592000 },
      { unit: 'day', secondsInUnit: 86400 },
      { unit: 'hour', secondsInUnit: 3600 },
      { unit: 'minute', secondsInUnit: 60 },
    ];

    for (const { unit, secondsInUnit } of units) {
      const diff = Math.floor(diffInSeconds / secondsInUnit);
      if (diff >= 1) {
        const rtf = new Intl.RelativeTimeFormat($localize.locale || 'en', { numeric: 'auto' });
        return rtf.format(-diff, unit);
      }
    }

    return $localize`Just now`;
  }
}
